import Vue from 'vue';
import ScrollBar from 'base/vue2-scrollbar/index'
import HeaderNav from 'business/HeaderNav'
import CommNav from 'business/CommNav'
import RightNav from 'business/RightNav'
import Sider from 'business/Sider'
import FooterNav from 'business/FooterNav'

const components = {
  HeaderNav,
  CommNav,
  RightNav,
  Sider,
  ScrollBar,
  FooterNav
}

Object.keys(components).forEach(key => {
  Vue.component(key, components[key])
})
